import React from 'react';
import { Flex, TextV2, TooltipV2, Box } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { Info } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { SkeletonText } from '@shared/components/Skeleton';

export const SpecialEventRatesTag = () => {
  const { t } = useTranslation('accommodationsConsole');
  const listingsTrans = t('listingsPanel');

  return (
    <Flex
      width={'full'}
      justifyContent="center"
    >
      <TooltipV2
        overrides={{
          Content: { props: { paddingY: 4, paddingLeft: pxToRem(14), paddingRight: 4, borderRadius: pxToRem(12), color: 'white', marginLeft: 2 } },
        }}
        content={
          <Flex
            flexDirection="column"
            maxWidth={pxToRem(256)}
          >
            <Box typographyVariant="label3">{listingsTrans.specialEventRates.tooltipTitle()}</Box>
            <Box
              typographyVariant="label2"
              color="mono4"
            >
              {listingsTrans.specialEventRates.tooltipContent()}
            </Box>
          </Flex>
        }
        placement="top"
        onMouseEnterDelay={500}
      >
        <Flex
          width={'full'}
          gap={3}
          justifyContent="center"
          alignItems="center"
        >
          <TextV2
            typographyVariant="button2"
            color="mono14"
          >
            {listingsTrans.specialEventRates.title()}
          </TextV2>
          <Info size={16} />
        </Flex>
      </TooltipV2>
    </Flex>
  );
};

SpecialEventRatesTag.Skeleton = () => {
  return (
    <Flex
      display={{ _: 'flex', md: 'none' }}
      width={'full'}
      justifyContent="center"
    >
      <Flex
        width={'full'}
        gap={3}
        justifyContent="center"
        alignItems="center"
      >
        <SkeletonText
          rows={1}
          width={200}
          skeletonHeight={24}
        />
        <SkeletonText
          rows={1}
          width={16}
          skeletonHeight={16}
        />
      </Flex>
    </Flex>
  );
};
